import * as yup from 'yup';

export const productFormSchema = yup.object({
    categorySelections: yup
        .array()
        .of(
            yup.object({
                sectionId: yup.mixed<number | ''>().required(),
                categoryId: yup.mixed<number | ''>().required(),
            })
        )
        .required('Необходимо выбрать хотя бы одну категорию')
        .min(1, 'Необходимо выбрать хотя бы одну категорию')
        .test(
            'at-least-one-category',
            'Необходимо выбрать хотя бы одну категорию',
            (value) => {
                if (!value || value.length === 0) return false;
                return value.some((item) => item.categoryId !== '' && item.categoryId !== null && item.categoryId !== undefined);
            }
        ),
    name: yup.string().required('Название товара обязательно для заполнения'),
    description: yup.string(),
    price: yup.number().required('Цена товара обязательна для заполнения').min(0, 'Цена не может быть отрицательной'),
    composition: yup
        .array()
        .of(
            yup.object({
                value: yup.string().optional().default(''),
                count: yup.number().optional().min(0, 'Количество не может быть отрицательным').default(0),
            })
        )
        .optional(),
    keywords: yup.array().of(yup.string().required()).optional(),
    height: yup.number().required('Высота обязательна для заполнения').min(0, 'Высота не может быть отрицательной'),
    width: yup.number().required('Ширина обязательна для заполнения').min(0, 'Ширина не может быть отрицательной'),
    weight: yup.number().required('Вес обязателен для заполнения').min(0, 'Вес не может быть отрицательным'),
    flowerCount: yup.number().optional(),
    isNotFlower: yup.boolean().optional(),
    flowerTypeIds: yup
        .array()
        .of(yup.number().required())
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать типы цветков').min(1, 'Необходимо выбрать хотя бы один тип цветка'),
            otherwise: (schema) => schema.optional(),
        }),
    assemblyTypeId: yup
        .number()
        .nullable()
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать тип сборки'),
            otherwise: (schema) => schema.optional(),
        }),
    colorIds: yup
        .array()
        .of(yup.number().required())
        .when('isNotFlower', {
            is: false,
            then: (schema) => schema.required('Необходимо выбрать цвета').min(1, 'Необходимо выбрать хотя бы один цвет'),
            otherwise: (schema) => schema.optional(),
        }),
    images: yup.array().of(yup.mixed<File | { id: number; url: string }>().required()).required('Необходимо загрузить изображения').min(1, 'Необходимо загрузить хотя бы одно изображение').max(10, 'Максимальное количество изображений - 10'),
});
